function GenerateThumbnail() {

}

GenerateThumbnail.events = {
    isInit: true,

    init: function() {
        var that = this;

        if (that.isInit) {
            $(".modifier_main_container").on("click", ".generate-thumbnail-container .perspective", that.onClickGenerateThumbnail);
            $(".modifier_main_container").on("click", ".generate-thumbnail-container .all-thumbnail", that.loadAllThumbnail);
            that.isInit = false;
        }
        ub.data.generateThumbnailShown = true;
        that.loadGenerateThumbnail();
    },

    loadGenerateThumbnail: function() {
        var template = document.getElementById("m-generate-thumbnail-controller").innerHTML;
        Mustache.render(template);

        $(".modifier_main_container").html("");
        $(".modifier_main_container").html(template);
    },

    onClickGenerateThumbnail: function() {
        ub.funcs.removeLocations();
        ub.funcs.deactivateMoveTool();

        var view = $(this).data("view");

        switch (view) {
            case "front":
                ub['front_view'].visible = true;
                RichardsonSkin.funcs.generateThumbnail(view);
                return;
             case "back":
                ub['back_view'].visible = true;
                RichardsonSkin.funcs.generateThumbnail(view);
                return;
            case "left":
                ub['left_view'].visible = true;
                RichardsonSkin.funcs.generateThumbnail(view);
                return;
            case "right":
                ub['right_view'].visible = true;
                RichardsonSkin.funcs.generateThumbnail(view);
                return;
            default:
                ub['front_view'].visible = true;
                ub['left_view'].visible  = true;
                ub['right_view'].visible = true;
                ub['back_view'].visible  = true;
        }

        RichardsonSkin.funcs.generateThumbnail(view);
    },

    loadAllThumbnail: function() {
        ub.funcs.removeLocations();
        ub.funcs.deactivateMoveTool();

        ub['front_view'].visible = true;
        ub['left_view'].visible  = true;
        ub['right_view'].visible = true;
        ub['back_view'].visible  = true;

        GenerateThumbnail.generateAllThumbnail();
    }

}

GenerateThumbnail.getThumbnails = function(){
    var images = [];
    _.each(ub.views, function(view){
        images.push({
            perspective: view,
            image: ub.getThumbnailImage(view + "_view")
        })
    });
    return images;
}

GenerateThumbnail.generateAllThumbnail = function(){
    var images = GenerateThumbnail.getThumbnails();
    var template = _.template(document.getElementById("m-generate-all-thumbnail").innerHTML);
    
    $("#thumbnails .thumbnail-list").html("");
    $("#thumbnails .thumbnail-list").html(template({
        thumbnails: images
    }));

    GenerateThumbnail.download();

    UIkit.modal("#thumbnails").show();
}

GenerateThumbnail.download = function(){
    var images = GenerateThumbnail.getThumbnails();
    var buttonEl = $('#thumbnails .download-all');
    var zip = new JSZip();

    _.each(images, object =>  {
        var {perspective, image} = object;
        var imageData = image.replace("data:image/png;base64,", '');

        zip.file(`${perspective}.png`, imageData, {
            base64: true
        });
    });

    zip.generateAsync({type:"base64"}).then(data => {
        buttonEl.attr({
            href: `data:application/zip;base64, ${data}`,
            download: `${ub.config.uniform_name}.zip`
        });

        buttonEl.removeClass('uk-disabled');
    }).catch(error => {
        console.error(error)
        UIkit.notification({message: "Something went wrong. Please try again.", status: 'danger', pos: 'top-right'});
    });
}